import { FC } from "react";

import { useMultiStyleConfig, Box } from "@chakra-ui/react";

import { TPhoneCodeOption } from "./types";

type TFlagIconProps = {
  option?: TPhoneCodeOption;
};

const FlagIcon: FC<TFlagIconProps> = ({ option }) => {
  const styles = useMultiStyleConfig("PhoneInput", {});

  if (!option?.flag) {
    return null;
  }

  return (
    <Box
      sx={styles.codeSelectFlag}
      backgroundPosition={option.flag.backgroundPosition}
      height={option.flag.height}
      aria-hidden
    />
  );
};
export default FlagIcon;
